import React, { useEffect, useRef, useState } from 'react'
import CustomModal from './Modal';
import styles from "./Environmentpanel.module.css"
import { create_environment_file_Api, delete_environment_api, delete_environment_file_Api, get_all_environment_file_Api, update_environment_Api } from '../../dashboardapi';
import data from "../../json/Config.json"
import { useToast } from '@chakra-ui/react';
import Loading from '../../components/Loading';


const Environmentfiles = ({ showModal, index, file, setshowdetails, fetchenvi }) => {
    const [dragging, setDragging] = useState(false);
    const fileInputRef = useRef(null);
    const [inputFiles, setInputFiles] = useState([]);
    const [environmentTitle, setEnvironmentTitle] = useState("");
    const [allEnvironmentFiles, setAllEnvironmentFiles] = useState([]);
    const [rename, setRename] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [filename, setFilename] = useState("");
    const [isLoading, setLoading] = useState(false);
    const toast = useToast();

    useEffect(() => {
        fetchallenvironmentfiles(file);
    }, []);

    useEffect(() => {
        setFilename(file.name)
    }, [file.name]);

    const fetchallenvironmentfiles = async (file) => {
        setLoading(true);

        try {
            let response = await get_all_environment_file_Api(file.uuid)

            if (response.data && response.data.length > 0) {
                setAllEnvironmentFiles(response.data)
            } else {
                // toast({
                //     title: "No files Uploaded",
                //     description: "Please upload files to the environment",
                //     status: "warning",
                //     duration: 2000,
                //     isClosable: "true"
                // })
                setAllEnvironmentFiles([]);
            }
        } catch (error) {
            //  console.log("Error fetching environment files:", error);

            // const error = response.error.message || "An error Occured"
            toast({
                title: "Problem getting Environmentfiles",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            });
            setAllEnvironmentFiles([]);
        } finally {
            setLoading(false);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true); // Highlight the area when dragging files
    };

    const handleDragLeave = () => {
        setDragging(false); // Remove highlight when leaving
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        handleFiles(files); // Handle dropped files
    };

    const handleFiles = (files) => {
        const fileslist = Array.from(files)
        setInputFiles((prev) => [...prev, ...fileslist])
    };

    const handleClick = () => {
        fileInputRef.current.click(); // Trigger file input click
    };

    const handleChange = (e) => {
        setEnvironmentTitle(e.target.value)
    }

    const handleDelete = async (envid, fileid) => {
        let result = await delete_environment_file_Api(envid, fileid);
        if (result.data) {
            toast({
                title: "Files deleted successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            fetchallenvironmentfiles(file)
        }
        else {
            let error = result.error.message || "An error Occured"
            toast({
                title: "Problem deleting files",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })

        }
    }

    const handlenewDelete = (todelete) => {
        setInputFiles((prev) => prev.filter(file => file.name != todelete))
    }

    const Renametitle = async (id, name) => {
        try {
            const result = await update_environment_Api(id, name);
            if (result.data) {
                fetchenvi()
            } else {
                const errorMessage = result.error?.message || "An error occurred";
                toast({
                    title: "Problem updating environment",
                    description: errorMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem updating environment",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const updateFiles = async (e) => {
        e.preventDefault();
        try {
            if (environmentTitle) {
                Renametitle(file.uuid, environmentTitle);
            }
            let result = await create_environment_file_Api(file.uuid, inputFiles);
            if (result.data) {
                toast({
                    title: "Environment updated successfully",
                    description: "",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
                fetchallenvironmentfiles(file)
                setInputFiles([])
                setshowdetails({ show: false })
            } else {
                const errorMessage = result.error.message || "An error occurred"
                toast({
                    title: "Problem uploading files",
                    description: errorMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem uploading files",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    // console.log(showDeleteModal);

    const handleenvdelete = async () => {
        try {
            let result = await delete_environment_api(file.uuid);
            if (result.data) {
                // console.log(result);
                toast({
                    title: "Environment deleted successfully",
                    description: result.data.message,
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
                setShowDeleteModal(false)
                setshowdetails({ show: false })
                fetchenvi();
            } else {
                console.log(result.error);

                let error = result.error.message || "An error occurred"
                toast({
                    title: "Problem deleting environment",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        }
        catch (error) {
            toast({
                title: "Problem deleting environment",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    return (
        <>
            <div className={styles.modalbackdrop}>
                <CustomModal show={showModal}>
                    <div className={styles.modalouter}>
                        <div style={{ padding: '24px', borderRight: '0.6px solid var(--border)', width: '50%' }}>
                            <div className={styles.modalheader}>
                                {data.environmenttitle}
                            </div>
                            <form className={styles.formouter} method='POST' onSubmit={updateFiles}>
                                <div className={styles.inputname} style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start" }}>
                                    <div style={{ width: "100%", display: "flex", gap: "10px", justifyContent: 'space-between' }}>
                                        <label >Title</label>
                                        <div style={{ color: "var(--error)" }}>
                                            {!rename ? <div onClick={() => setRename(true)} style={{ width: "100%", display: "flex", justifyContent: "center", paddingTop: "10px", fontSize: "14px" }}>Rename</div> : <div onClick={() => setRename(false)} style={{ width: "100%", display: "flex", justifyContent: "center", color: "var(--error)", fontSize: "14px" }}>Cancel</div>}
                                        </div>

                                    </div>
                                    <div style={{ width: "100%" }}>
                                        {!rename ?
                                            <p style={{ fontSize: "18px", fontWeight: "600", marginBottom: "20px" }}>{filename}</p> :
                                            <><input type='text' name='environment_name' maxLength={50} onChange={handleChange} placeholder='Enter Environment Name' required /><span></span></>}
                                    </div>
                                </div>
                                <div className={`${styles.inputdiv} ${dragging ? styles.dragging : ''}`} onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}>
                                    {dragging ? (
                                        // When dragging, show this content
                                        <div style={{ height: '133px' }}>
                                            Drag your file here
                                        </div>
                                    ) : (
                                        <>
                                            <p>
                                                {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/upload_img.png"} alt='' /> */}
                                                <svg width="47" height="42" viewBox="0 0 47 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M30.9463 3.77734C31.3003 3.77734 31.5879 4.06488 31.5879 4.41895C31.5879 4.773 31.3004 5.06055 30.9463 5.06055C28.2931 5.06073 25.9029 6.77951 25.0469 9.27051L24.9688 9.51367C24.8781 9.81953 24.5795 10.005 24.2715 9.96387L24.2637 9.97363L24.1719 9.94531C23.8327 9.84417 23.6391 9.4879 23.7402 9.14844C24.6617 6.052 27.5312 3.77753 30.9463 3.77734Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="0.3" />
                                                    <path d="M37.8229 28.4884H34.8757C34.6045 28.4884 34.3845 28.2684 34.3845 27.9972C34.3845 27.726 34.6045 27.506 34.8757 27.506H37.8229C41.8854 27.506 45.1909 24.2005 45.1909 20.138C45.1909 16.0754 41.8854 12.7699 37.8229 12.7699H37.752C37.6096 12.7699 37.4741 12.7082 37.3808 12.6005C37.2875 12.4928 37.2454 12.35 37.2657 12.2089C37.3096 11.903 37.3317 11.5956 37.3317 11.2963C37.3317 7.77549 34.4669 4.91068 30.946 4.91068C29.5763 4.91068 28.27 5.33873 27.1683 6.14885C26.9262 6.32674 26.5823 6.2478 26.4424 5.98149C23.3222 0.0400754 15.1726 -0.757796 10.9475 4.41072C9.16764 6.58813 8.4683 9.42061 9.02869 12.1812C9.09044 12.4861 8.85711 12.7703 8.54731 12.7703H8.35047C4.28792 12.7703 0.982451 16.0758 0.982451 20.1383C0.982451 24.2009 4.28792 27.5064 8.35047 27.5064H11.2976C11.5689 27.5064 11.7889 27.7263 11.7889 27.9976C11.7889 28.2688 11.5689 28.4888 11.2976 28.4888H8.35047C3.74612 28.4888 0 24.7427 0 20.1383C0 15.6631 3.53873 11.9987 7.96488 11.7966C7.54911 8.93254 8.34416 6.04357 10.1868 3.789C14.7104 -1.74508 23.3796 -1.12478 27.0443 5.04612C28.2134 4.31317 29.5511 3.92867 30.9459 3.92867C35.2116 3.92867 38.5918 7.55937 38.296 11.8012C42.6814 12.0472 46.1731 15.6922 46.1731 20.1379C46.1731 24.7427 42.427 28.4884 37.8227 28.4884L37.8229 28.4884Z" fill="var(--btn-bg)" />
                                                    <path d="M23.0205 14.6895C30.206 14.6895 36.0508 20.5342 36.0508 27.7197C36.0507 34.9051 30.206 40.75 23.0205 40.75C15.8351 40.75 9.99028 34.9053 9.99023 27.7197C9.99023 20.5343 15.8349 14.6895 23.0205 14.6895ZM23.0205 17.1719C17.2053 17.1719 12.4727 21.9046 12.4727 27.7197C12.4727 33.5349 17.2054 38.2676 23.0205 38.2676C28.8356 38.2675 33.5683 33.5348 33.5684 27.7197C33.5684 21.9045 28.8356 17.1719 23.0205 17.1719Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="1.5" />
                                                    <path d="M23.2444 33.0224C23.0458 33.0224 22.8848 32.8614 22.8848 32.6628V23.3127C22.8848 23.1142 23.0458 22.9531 23.2444 22.9531C23.4429 22.9531 23.604 23.1142 23.604 23.3127V32.6628C23.604 32.8616 23.4429 33.0224 23.2444 33.0224Z" fill="var(--btn-bg)" />
                                                    <path d="M26.1213 26.5503C26.0294 26.5503 25.9371 26.5151 25.867 26.445L23.2444 23.8224L20.6218 26.445C20.4815 26.5855 20.2537 26.5855 20.1132 26.445C19.9727 26.3045 19.9727 26.0769 20.1132 25.9364L22.9901 23.0595C23.1303 22.919 23.3582 22.919 23.4987 23.0595L26.3756 25.9364C26.5161 26.0769 26.5161 26.3045 26.3756 26.445C26.3055 26.5154 26.2132 26.5503 26.1213 26.5503H26.1213Z" fill="var(--btn-bg)" />
                                                </svg>

                                            </p>
                                            <div>Upload your files</div>
                                            <p>Drag and drop your files here or <a onClick={handleClick} >choose files</a></p>
                                            <input
                                                type='file'
                                                name='project_name'
                                                placeholder='Enter Project Name'
                                                ref={fileInputRef}
                                                style={{ display: 'none' }} // hide the file input
                                                multiple
                                                onChange={(e) => handleFiles(e.target.files)}
                                                accept='.tex, .bib, .pdf, .png, .jpg, .jpeg, .dtx, .ins, .bst, .sty, .eps, .cls'
                                            />
                                        </>
                                    )}
                                </div>

                                <div className={styles.actionbtn}>
                                    <button className={styles.btn1} onClick={() => setshowdetails({ show: false })}>Cancel</button>
                                    <button className={styles.btn2} type='submit'>Update</button>
                                </div>
                            </form>
                            <div className={styles.deleteenvbtn}>
                                <button onClick={() => setShowDeleteModal(true)} style={{ fontSize: "14px" }}>Delete Environment</button>
                            </div>
                        </div>

                        {/* New files to Upload */}
                        {
                            inputFiles && inputFiles.length > 0 && <div div style={{ paddingBottom: '24px', width: '50%' }}>
                                <div className={styles.modalheader} style={{ padding: '24px 24px 18px 24px', borderBottom: '0.6px solid var(--border)' }}>
                                    Files to Upload
                                </div>
                                <div className={`${styles.envi_list} ${styles.scrollable}`} style={{ marginTop: '24px' }}>
                                    {inputFiles ? inputFiles.map((indfile, id) => (
                                        <>
                                            <div key={id}>
                                                <span style={{ width: "70%" }}>
                                                    <p>{indfile.name}</p>
                                                    <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>{indfile.type} I {indfile.size < 1000000 ? (indfile.size / 1024).toFixed(2) : indfile.size} {indfile.size < 1000000 ? "KB" : "MB"} </p>
                                                </span>
                                                <button onClick={() => handlenewDelete(indfile.name)}>
                                                    {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='' /> */}
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_45_3546)">
                                                            <path d="M3.33398 5.83301H16.6673" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M8.33398 9.16699V14.167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M11.666 9.16699V14.167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_45_3546">
                                                                <rect width="20" height="20" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </button>
                                            </div>
                                        </>
                                    )) : ""}
                                </div>
                            </div>
                        }

                        {/* Already uploaded files */}
                        {/*List Modal Header */}
                        <div style={{ paddingBottom: '24px', width: '50%' }}>
                            <div className={styles.modalheader} style={{ padding: '24px 24px 18px 24px', borderBottom: '0.6px solid var(--border)' }}>
                                Uploaded Files
                            </div>

                            {/*Uploaded List Modal*/}
                            {isLoading ? (<Loading loading={isLoading} inline />) :
                                <div className={`${styles.envi_list} ${styles.scrollable}`} style={{ marginTop: '24px' }}>
                                    {allEnvironmentFiles.length > 0 ? allEnvironmentFiles.map((indfile, id) => (
                                        <>
                                            {console.log(indfile.size)}
                                            <div key={id}>
                                                <span style={{ width: "70%" }}>
                                                    <p>{indfile.name}</p>
                                                    <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>{indfile.type} I {`${indfile.size.toFixed(2)} MB`} </p>
                                                </span>
                                                <button onClick={() => handleDelete(file.uuid, indfile.uuid)}>
                                                    {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='' /> */}
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_45_3546)">
                                                            <path d="M3.33398 5.83301H16.6673" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M8.33398 9.16699V14.167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M11.666 9.16699V14.167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_45_3546">
                                                                <rect width="20" height="20" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </button>
                                            </div>
                                        </>
                                    )) : "No files to show"}
                                </div>}
                        </div>
                    </div >
                </CustomModal >
            </div >

            {showDeleteModal ? <div className={styles.secondmodalbackdrop}>
                <div className={styles.secondmodalcontent}>
                    <CustomModal show={showDeleteModal}>
                        <div style={{ padding: "40px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <h1>Do You wish to Delete Environment?</h1>
                            <div className={styles.actionbtn}>
                                <button className={styles.btn1} onClick={() => { setShowDeleteModal(false) }}>Cancel</button>
                                <button className={styles.btn2} onClick={handleenvdelete}>Delete</button>
                            </div>
                        </div>
                    </CustomModal>
                </div>
            </div> : ""}
        </>
    )

}

export default Environmentfiles;